export const EVENT_PROFILE_CUSTOMER_CREATE = 'profileCustomer.create'
export const EVENT_PROFILE_CUSTOMER_UPDATE = 'profileCustomer.update'
